<template>
    <div class="background-container">
        <div
            class="containerrr"
        >
            <div
                class="title"
            >
                <span
                    style="font-size: 24px; font-weight: 600; color: #663399"
                >
                    {{ screen_data.title }}
                </span>
                <button
                    @click="closePopup()"
                >
                    <AppIcon :src="require('@/assets/close_small.svg')" :size="10" :color-map="{ '351457': 'primaryDark' }"/>
                </button>
            </div>
            <div
                class="content"
            >
                <div
                    v-if="screen_data.view === 'payment_details'"
                >
                    <div
                        style="display: flex; align-items: center; border: 1px solid purple; padding: 10px 0px"
                    >
                        <div
                            v-for="header in screen_data.headers"
                            style="width: 33%; display: flex; align-items: center; justify-content: center;"
                        >
                            <span
                                style="font-size: 18px; font-weight: 500; color: purple"
                            >
                                {{ header.name }}
                            </span>
                        </div>
                    </div>
                    <div
                        v-if="screen_data.selected_charge_for_pay_charge_popup && screen_data.selected_charge_for_pay_charge_popup.invoice_lines && screen_data.selected_charge_for_pay_charge_popup.invoice_lines.length > 0"
                        style="width: 100%"
                    >
                        <div
                            v-for="invoice_line in screen_data.selected_charge_for_pay_charge_popup.invoice_lines"
                            style="width: 100%; display: flex; border-left: 1px solid purple; border-right: 1px solid purple; border-bottom: 1px solid purple; padding: 10px 0px"
                        >
                            <div
                                v-for="header in screen_data.headers"
                                style="width: 33%; display: flex; align-items: center; justify-content: center;"
                            >
                                <span
                                >
                                    {{ invoice_line[header.value_with_multiple_lines] }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div
                        v-else
                        style="display: flex; align-items: center; border-left: 1px solid purple; border-right: 1px solid purple; border-bottom: 1px solid purple; padding: 10px 0px"
                    >
                        <div
                            v-for="header in screen_data.headers"
                            style="width: 33%; display: flex; align-items: center; justify-content: center;"
                        >
                            <span
                            >
                                {{ screen_data.selected_charge_for_pay_charge_popup[header.value_with_a_single_line] }}
                            </span>
                        </div>
                    </div>
                    <div class="div-row" style="justify-content: space-between; align-items: center; margin-top: 40px;">
                        <div style="font-size: 24px; font-weight: 600; color: #262626">TOTAL</div>
                        <div style="font-size: 16px; font-weight: 600; color: #565656">
                            {{screen_data.tax_name}} ({{ screen_data.tax }}%)
                        </div>
                    </div>
                    <div class="div-total">
                        <span style="font-size: 16px; font-weight: 600; margin-right: 10px; color: #262626;">
                            {{ component.calculateToPay() }} €
                        </span>
                    </div>
                    <button
                        class="button-siguiente"
                        style="margin-top: 15px"
                        @click="component.next()"
                    >
                        Siguiente
                    </button>
                </div>
                <div
                    v-else-if="screen_data.view === 'payment_method'"
                >
                    <button 
                        class="back-box"
                        @click="component.changeView('payment_details')"
                    >
                        <AppIcon :src="require('@/assets/keyboard_backspace.svg')" :size="14" :preserveColors="true"/> 
                        Atrás
                    </button>
                    <div class="payment-box">
                        <div style="font-size: 16px; font-weight: 500; color: #565656">Selecciona una forma de pago</div>
                        <div class="div-row" style="margin-top: 10px">
                            <button
                            :class="['payment-method-button', 'center-div', { selected: screen_data.payment_method == 'transfer' }]"
                                @click="component.changePaymentMethod('transfer')"
                            >
                                <AppIcon :src="require('@/assets/send_money_color.svg')" :size="20" v-if="screen_data.payment_method == 'transfer'" />
                                <AppIcon :src="require('@/assets/send_money.svg')" :size="20" v-else-if="screen_data.payment_method == 'card'" :preserveColors="true" />
                                <span>&nbsp;Transferencia</span>
                            </button>
                            <button
                                v-if="got_feature('feature_pay_with_card')"
                                :class="['payment-method-button', 'center-div', { selected: screen_data.payment_method == 'card' }]"
                                style="margin-left: 15px;"
                                @click="component.changePaymentMethod('card')"
                            >
                                <AppIcon :src="require('@/assets/credit_card.svg')" :size="20" v-if="screen_data.payment_method == 'transfer'" />
                                <AppIcon :src="require('@/assets/credit_card_color.svg')" :size="20" v-else-if="screen_data.payment_method == 'card'" />
                                <span>&nbsp;Tarjeta</span>
                            </button>
                        </div>
                    </div>
                    <div v-if="screen_data.payment_method == 'transfer'">
                        <div style="font-size: 16px; font-weight: 500; color: #565656">Cuenta de Inmatic</div>
                        <div style="font-size: 16px; font-weight: 600; color: #3D3D3D; margin-top: 10px;">BANCO SABADELL IBAN: ES04 0081 0400 1100 0123 0926</div>
                        <div style="font-size: 16px; font-weight: 400; color: #565656; margin-top: 10px;">En el beneficiario indica Coneptum S.L. En el concepto indique usuario y el plan seleccionado.</div>
                        <v-file-input
                            :key="screen_data.file_input_key"
                            v-model="screen_data.payment_file"
                            outlined
                            prepend-icon=""
                            prepend-inner-icon="mdi-paperclip"
                            name="uploader"
                            label="Adjuntar justificante de pago"
                            class="file-input--outlined rounded-lg pb-2"
                            style="margin-top: 30px"
                            hide-details
                            dense
                            @change="component.changeFile()"
                        />
                        <span
                            v-if="screen_data.file_input_error"
                            style="font-size: 16px; font-weight: 500; color: red"
                        >
                            *Solo se aceptan ficheros tipo pdf*
                        </span>
                        <button
                            :class="[component.isDisabledPayWithTransfer() ? 'button-siguiente disabled' : 'button-siguiente']"
                            style="margin-top: 20px;"
                            :disabled="component.isDisabledPayWithTransfer()"
                            @click="() => handlePayWithTransfer()"
                        >
                            <span style="font-size: 14px; font-weight: 500; color: var(--v-neutral-base)">Continuar con el pago</span>
                        </button>
                    </div>
                    <div v-if="screen_data.payment_method == 'card'" class="card-box">
                        <div>Serás redirigido a Stripe, nuestra pasarela de pago segura. En Stripe ingresarás los datos de tu tarjeta de forma protegida.</div>
                        <v-radio-group
                            v-if="screen_data.used_card.last4"
                            v-model="screen_data.used_card.use_old_card"
                            mandatory
                            class="my-0 py-0"
                            hide-details
                            style="margin-left:0.75rem;"
                        >
                            <v-radio
                                :label="`Pagar con la Tarjeta acabada en ****${screen_data.used_card.last4}`"
                                :value="true"
                                class="my-0 py-0"
                            />
                            <div style="height:20px;">&nbsp;</div>
                            <v-radio
                                label="Pagar con una nueva Tarjeta"
                                :value="false"
                                class="my-0 py-0"                                                
                            />
                        </v-radio-group>
                        <button
                            class="button-siguiente"
                            style="margin-top: 20px;"
                            @click="() => component.payWithCard()"
                        >
                            <span style="font-size: 14px; font-weight: 500; color: var(--v-neutral-base)">
                                Continuar con el pago
                            </span>
                        </button>
                    </div>
                </div>
                <div
                    v-else-if="screen_data.view === 'loading'"
                    style="display: flex; height: 100%; justify-content: center; align-items: center;"
                >
                    <v-progress-circular
                        indeterminate
                        color="var(--v-primary-base)"
                        size="40"
                    />
                </div>
                <div 
                    v-else-if="screen_data.view === 'success'"    
                    style="width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;"
                >
                    <AppIcon :src="require('@/assets/check_circle_strong_green.svg')" :size="40" :preserveColors="true"/>
                    <span class="final-box-message">
                        Agradecemos tu confianza en Inmatic y nos alegra contar contigo. En unos minutos podrás encontrar tu recibo en el área de cliente, dentro de la sección 'Mis Datos'. Si necesitas ayuda o deseas más información, no dudes en contactarnos.
                    </span>
                    <button class="end-button" @click="closePopup()">Finalizar</button>
                </div>
                <div
                    v-else-if="screen_data.view === 'fail'"
                    style="width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;"
                >
                    <AppIcon :src="require('@/assets/gpp_bad.svg')" :size="40" :preserveColors="true"/>
                    <div class="final-box-message">
                        {{ screen_data.error_message? screen_data.error_message : "Hubo un error al procesar tu pago. Por favor, inténtalo de nuevo o contacta con soporte si el problema persiste." }}
                    </div>
                    <button class="end-button" @click="closePopup()">Finalizar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import { mapActions, mapGetters, mapState } from "vuex"
import { mapFields } from 'vuex-map-fields';
import awsconfig from '../aws-exports';
import { S3Repository } from '@/modules/shared/infra/S3Repository';
import { PayChargePopupScreenData } from '@/modules/revenue/domain/PayChargePopupScreenData';
import { PayChargePopupAllCommands } from '@/modules/revenue/app/PayChargePopupAllCommands';
import { ApiPayChargePopupRepository } from '@/modules/revenue/infra/ApiPayChargePopupRepository';

export default {
    name: 'PayChargePopup',

    props: {

    },

    data(){
        const screen_data = new PayChargePopupScreenData()
        return {
            screen_data: screen_data,
            component: null,
        }
    },

    async created() {
        this.setupAWSCredentials();
        const file_repo = new S3Repository(AWS);
        this.component = new PayChargePopupAllCommands(this.screen_data, new ApiPayChargePopupRepository(), file_repo);
        await this.component.run(this.selected_charge_for_pay_charge_popup);
    },

    beforeDestroy() {
        window.removeEventListener('message', this.screen_data.message_listener)
    },

    computed: {
        ...mapFields('dialog_payment', ['selected_charge_for_pay_charge_popup']),
        ...mapState(['session_information']),
        ...mapGetters({
            got_feature: 'got_feature',
        }),
    },

    methods: {
        ...mapActions({
            closePayChargePopup: "dialog_payment/closePayChargePopup",
            forceRefreshUserData: 'me/forceRefreshUserData',
        }),

        setupAWSCredentials() {
            const session = this.session_information;
            if (!session || !session.signInUserSession) {
                throw new Error('Sesión no disponible. Por favor, recarga la página.');
            }
            this.creds = new AWS.CognitoIdentityCredentials({ IdentityPoolId: awsconfig['aws_cognito_identity_pool_id'] });
            this.creds.params = this.creds.params || {};
            this.creds.params.Logins = this.creds.params.Logins || {};
            this.creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] = session.signInUserSession.idToken.jwtToken;
            this.creds.expired = true;
            AWS.config.update({
                region: awsconfig['aws_user_files_s3_bucket_region'],
                credentials: this.creds,
            });
        },

        async handlePayWithTransfer() {
            await this.component.payWithTransfer(async () => {
                await this.forceRefreshUserData();
            });
        },
        
        closePopup(){
            this.closePayChargePopup()
        }
    }
}
</script>
<style scoped>

.background-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5); 
    z-index: 1000; 
    opacity: 1;
}

.containerrr{
    width: 700px;
    height: 600px;
    background-color: white;
    border-radius: 10px;
    z-index: 1001; 
}

.title {
    width: 100%;
    height: 70px;
    display:flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 24px 24px 24px 48px;
    border-bottom: 1px solid #e7e7e7;
    box-sizing: border-box;
}

.content {
    width: 100%;
    height: 530px;
    padding: 24px 48px 24px 48px;
}

.div-row {
    display: flex;
    width: 100%;
}

.div-total {
    width: 100%;
    height: 32px;
    display: flex;
    justify-content: right;
    align-items: center;
    border: 1px solid #262626;
    border-radius: 2px;
}

.button-siguiente {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 160px;
    border-radius: 8px;
    background-color: #7339B7;
    color: white
}

.button-siguiente.disabled {
    background-color: #B0B0B0;
}

.default-text {
    font-size: 18px; 
    font-weight: 400;
}

.default-text.bold{
    font-weight: 600;
}

.line {
    height: 1px; 
    background-color: #e0e0e0; 
    margin: 10px 0px 10px 0px;
}

.line.bold {
    background-color: #9a9a9a; 
    margin: 15px 0px 15px 0px;
}

.back-box {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 51px;
    font-weight: 700;
    font-size: 13px;
    color: #888888;
    cursor: pointer;
    user-select: none;
}

.payment-box {
    width: 100%;
    margin-bottom: 48px;
}

.payment-method-button {
    background-color: #F3F3F3;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    height: 40px;
    font-weight: 500;
    color: #454545;
    cursor: pointer;
}
.payment-method-button.selected {
    background-color: #f9f6fe;
    border: 1px solid var(--v-primary-base);
    color: var(--v-primary-base);
}

.center-div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.card-box {
    width: 550px;
    color: #6D6D6D;
}

.final-box-message {
    width: 90%;
    text-align: center;
    margin-top: 30px;
    font-size: 16px;
    font-weight: 500;
    color: #565656
}

.end-button {
    width: 182px;
    height: 40px;
    margin-top: 40px;
    background-color: #454545;
    color: var(--v-neutral-base);
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
}

</style>